import React from "react";

import authService from "../../utils/services/authService";
import styles from "./sidebar.module.scss";
import AdminMenu from "./user-menus/AdminMenu";
import CompMenu from "./user-menus/CompMenu";
import DevMenu from "./user-menus/DevMenu";

const Sidebar = ({ isOpen, clickHandle, setIsNavOpen }) => {
  const userData = authService.getUserData();

  return (
    <div className={`${styles.sidebar} ${isOpen ? styles.open : ""}`}>
      <div className={styles.close}>
        <div className={styles.hamburger} onClick={clickHandle}>
          <span
            className={`${styles.hamburger_lines} ${isOpen ? styles.open : ""}`}
          ></span>
        </div>
      </div>
      {userData.role === "developer" && (
        <DevMenu userData={userData} setIsNavOpen={setIsNavOpen} />
      )}

      {userData.role === "company" && (
        <CompMenu userData={userData} setIsNavOpen={setIsNavOpen} />
      )}
      {userData.role === "admin" && (
        <AdminMenu userData={userData} setIsNavOpen={setIsNavOpen} />
      )}
    </div>
  );
};

export default Sidebar;
